import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbc8fd6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fullorder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThreeScene = _resolveComponent("ThreeScene")!
  const _component_ThreeRandselBag = _resolveComponent("ThreeRandselBag")!
  const _component_ThreeRandselAnimation = _resolveComponent("ThreeRandselAnimation")!
  const _component_ThreeScreenshot = _resolveComponent("ThreeScreenshot")!
  const _component_RandselLoadingCircle = _resolveComponent("RandselLoadingCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ThreeScene),
    _createVNode(_component_ThreeRandselBag),
    _createVNode(_component_ThreeRandselAnimation),
    _createVNode(_component_ThreeScreenshot),
    _createVNode(_component_RandselLoadingCircle)
  ]))
}